const ArrowsIndexRight = [
  {
    name: "arrow_gray_black",
  },
  {
    name: "arrow_lightTurquoise_black",
  },
  {
    name: "arrow_lightPink_black",
  },
]

const ArrowsIndexLeft = [
  {
    name: "arrow_lightOrange_black",
  },
  {
    name: "arrow_lightRed_black",
  },
  {
    name: "arrow_lightBlue_black",
  },
]

export { ArrowsIndexLeft, ArrowsIndexRight }
